import React from 'react';

const LoadingIndicator = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        top: '10px',
        right: '13px'
      }}
    >
      <div
        style={{
          border: '2px solid rgba(0, 0, 0, 0.1)',
          borderLeftColor: '#000',
          borderRadius: '50%',
          width: '12px',
          height: '12px',
          animation: 'spin 1s linear infinite'
        }}
      />
      <style>
        {`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}
      </style>
    </div>
  );
};

export default LoadingIndicator;
